import { render, staticRenderFns } from "./marketObservation.vue?vue&type=template&id=d587a9f0&scoped=true"
import script from "./marketObservation.vue?vue&type=script&lang=js"
export * from "./marketObservation.vue?vue&type=script&lang=js"
import style0 from "./marketObservation.vue?vue&type=style&index=0&id=d587a9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d587a9f0",
  null
  
)

export default component.exports